// extracted by mini-css-extract-plugin
export default {"zoomControls":"Maa-z","zoomControlButton":"Naa-z","zoomBanner":"Oaa-z","bannerButton":"Paa-z","imageButton":"Qaa-z","zoom":"Raa-z","zoomContent":"Saa-z"};